import { getFileExtension } from "lib/actions/files";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";
import ZipFileUploadIssue from "./filetype-dialog-content/ZipFileUploadIssue";
import TifUploadIssue from "./filetype-dialog-content/TifUploadIssue";

const UploadIssueFileDetails = () => {
  const { selectedUploadIssue } = useUploadPreprocessor();

  const fileExtension = getFileExtension(selectedUploadIssue.file.name);

  return (
    <div className="space-y-6">
      {fileExtension === "tif" && <TifUploadIssue />}
      {fileExtension === "zip" && <ZipFileUploadIssue />}
    </div>
  );
};

export default UploadIssueFileDetails;
